import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Dialog, DialogContent } from '../../ui/feedback/Dialog';
import { Button } from '../../ui/input/Button';
import { Flex } from '../../ui/layout/Flex';
import { Typography } from '../../ui/typography/Typography';
import { useBackButton } from '../../utils/useBackButton';
import { useTranslation } from '../../utils/useTranslation';

export function WithoutRangeDialog() {
    const t = useTranslation();
    const onNavigateBack = useBackButton();
    const { state } = useLocation();
    const { editLink } = state;

    return (
        <Dialog height="auto" borderRadius={3} maxWidth={{ xs: 'calc(100% - 32px)', sm: 580 }}>
            <DialogContent py={2} px={2}>
                <Typography variant="title3" weight="bold" pb={2}>
                    {t('Скрыт из ленты')}
                </Typography>
                <Typography variant="body2" pb={2}>
                    {t(
                        'Посты профиля исключены из ранжирования в ленте и доступны только в самом профиле или по прямой ссылке. Это можно изменить в настройках профиля.',
                    )}
                </Typography>
                <Flex direction="row" justifyContent="center" spacing={1} width="100%">
                    <Button as={Link} to={editLink} variant="filled" color="primary" width="50%">
                        {t('Настройки')}
                    </Button>
                    <Button variant="filled" color="primary" width="50%" onClick={onNavigateBack}>
                        {t('Хорошо')}
                    </Button>
                </Flex>
            </DialogContent>
        </Dialog>
    );
}
